module.exports = __webpack_public_path__ + "static/img/3.0a1d8f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/3.png
// module id = oqSZ
// module chunks = 0